import type Quill from 'quill';

export function installPlainTextCopy(quill: Quill, button: HTMLElement, notify: (message: string, error?: boolean) => void) {
  button.addEventListener('click', async () => {
    // Restoring focus also restores the selection after a toolbar click or Tab.
    const range = quill.getSelection(true);
    const text = range && range.length > 0
      ? quill.getText(range.index, range.length)
      : quill.getText(0, Math.max(0, quill.getLength() - 1));
    if (!text) {
      notify('No text to copy');
      return;
    }
    try {
      await navigator.clipboard.writeText(text);
      notify('Plain text copied');
    } catch {
      notify('Could not copy plain text. Check clipboard permissions and try again.', true);
    }
  });
}
